import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//data inicial
const dataInicial = {
    data: [],
    historialCompras: [],
    historialEntregas: [],
    entregasParciales: []
}

//types
const INVENTARIOS_CLIENTE_EXITO = 'INVENTARIOS_CLIENTE_EXITO'
const AGREGAR_INVENTARIO_EXITO = 'AGREGAR_COMPRA_EXITO'
const ACTUALIZAR_INVENTARIO_EXITO = 'ACTUALIZAR_INVENTARIO_EXITO'
const HISTORIAL_COMPRAS_FOLIOS = 'HISTORIAL_COMPRAS_FOLIOS'
const HISTORIAL_ENTREGAS = 'HISTORIAL_ENTREGAS'
const ENTREGAS_PARCIALES = 'ENTREGAS_PARCIALES'

export const obtenerInventarios = createAsyncThunk(
    INVENTARIOS_CLIENTE_EXITO,
    async () => {
        try {
            const fullUrl = host + `ModuloInventario/obtenerTodosInventarios`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const agregarInventario = createAsyncThunk(
    AGREGAR_INVENTARIO_EXITO,
    async (data) => {
        try {
            const fullUrlnventario = host + `ModuloInventario/AgregarInventario`
            let res = await axios.post(fullUrlnventario, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const actualizarInventario = createAsyncThunk(
    ACTUALIZAR_INVENTARIO_EXITO,
    async (data) => {
        try {
            const fullUrlnventario = host + `ModuloInventario/actualizarInventario`
            let res = await axios.put(fullUrlnventario, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const historialComprasFolios = createAsyncThunk(
    HISTORIAL_COMPRAS_FOLIOS,
    async (idlogin) => {
        try {
            const fullUrl = host + `ModuloInventario/obtenerHistorialFolios/${idlogin}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const historialEntregasHologramas = createAsyncThunk(
    HISTORIAL_ENTREGAS,
    async (idlogin) => {
        try {
            const fullUrl = host + `ModuloInventario/obtenerHistorialEntregas/${idlogin}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const entregasParciales = createAsyncThunk(
    ENTREGAS_PARCIALES,
    async (idInfoEntrega) => {
        try {
            const fullUrl = host + `ModuloInventario/obtenerEntregasParciales/${idInfoEntrega}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)


export const ModuloInventarioSlice = createSlice({
    name: 'ModuloInventarioSlice',
    initialState: dataInicial,
    reducers: {},
    extraReducers: {
        [obtenerInventarios.fulfilled]: (state, { payload }) => {
            state.data = payload
        },
        [historialComprasFolios.fulfilled]: (state, { payload }) => {
            state.historialCompras = payload
        },
        [historialEntregasHologramas.fulfilled]: (state, { payload }) => {
            state.historialEntregas = payload
        },
        [entregasParciales.fulfilled]: (state, { payload }) => {
            state.entregasParciales = payload
        }
    },
})

export const { } = ModuloInventarioSlice.actions

export const ModuloInventarioReducer = ModuloInventarioSlice.reducer
